
import {Component, Prop, Vue} from "vue-property-decorator";
  import {ICar} from "@/modules/Car/interfaces/car.interface";
  import {IAuth} from "@/modules/Auth/interfaces/auth.interface";
import {IAppState} from "@/interfaces/app-state.interface";

  @Component({})
  export default class PayGuestHoursField extends Vue {

    get storeState(): IAppState { return this.$store.state; }
    get payGuestHoursFlag() { return this.storeState.carList.payGuestHoursFlag; }
    get formModel(): ICar.IEntity { return this.storeState.car.formData.formModel; }
    get startForm(): ICar.IEntity { return this.storeState.car.formData.startForm; }

    get userAccess(): IAuth.UserAccess { return this.storeState.auth.userAccess; }
    get viewMode() { return !this.userAccess.scCarMk; }

    get modelValue() { return this.formModel.payGuestHours; }
    set modelValue(value) {
      this.$store.commit('car/setFormProperty', {
        formName: 'formModel',
        name: 'payGuestHours',
        value
      });
    };

    payGuestHours(value) {
      this.modelValue = Number(String(value).replace(/\D/g, ''));
      this.$emit('formItemChange');
    }
  }
